export function useLayoutFlags() {
  // useState, not module-level refs: a module-level ref is shared across requests on the
  // Workers isolate, so a flag set by one page leaks into the next. P180PCM-296.
  const showScrollToForm = useState<boolean>('layout:showScrollToForm', () => false)
  const showFooterForm = useState<boolean>('layout:showFooterForm', () => false)
  const showSidebarForm = useState<boolean>('layout:showSidebarForm', () => false)
  const showSidebarContactInfo = useState<boolean>('layout:showSidebarContactInfo', () => false)

  return {
    showFooterForm,
    showScrollToForm,
    showSidebarForm,
    showSidebarContactInfo,
  }
}

/**
 * Which of the two contact-form mounts a page renders. Both embed the same
 * ContactSettings form, so the sidebar wins when a page asks for both.
 */
export function resolveContactFormPlacement(input: {
  sidebarContactForm: boolean
  sidebarNav: boolean
  footerFormAllowed: boolean
}): { showFooterForm: boolean, showSidebarForm: boolean } {
  // Sidebar nav replaces the whole aside, so the sidebar form never renders beside it.
  const showSidebarForm = input.sidebarContactForm && !input.sidebarNav

  return {
    showSidebarForm,
    showFooterForm: input.footerFormAllowed && !showSidebarForm,
  }
}
